var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m18.264 11.9-6.718 6.717a4.5 4.5 0 0 1-6.364 0v0a4.5 4.5 0 0 1 0-6.364l.177-.177L8 9.5m6.02-1.843-6.818 6.818a1.5 1.5 0 0 0 0 2.122v0a1.5 1.5 0 0 0 2.122 0l8.232-8.233a3 3 0 0 0 0-4.243v0a3 3 0 0 0-4.242 0L12.076 5.36l-1.68 1.68"
  })));
};
export default SvgPaperclip;